import { JobAreaSummary, WorkOrderQuoteArea } from '../../../job/models/job.area.summary.interface';
import { WorkOrderEdit } from '../../../job/models/work.order.edit.interface';
import { JobService } from '../../../job/services/job.service';
import { Crew } from '../../models/crew.interface';
import { Job } from '../../models/job.interface';
import { WorkOrderType } from '../../models/work.order.type.interface';
import { DateService } from '../../services/date.service';
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { JobCustomItem, WorkOrderCustom } from '../../models/job.custom.item.interface';

export interface WorkOrderDialogData {
  quoteId: number;
  workOrderId: number;
  defaultWorkOrderStart: string;
  defaultWorkOrderStop: string;

  times: string[];
  crews: Crew[];
  workOrderTypes: WorkOrderType[];
}

export interface WorkOrderEditModel {
  workOrder: WorkOrderEdit;

  startTime: string;
  stopTime: string;
}

@Component({
  selector: 'app-work-order-dialog',
  templateUrl: './work.order.dialog.html',
  styleUrls: ['./work.order.dialog.scss']
})
export class WorkOrderDialog extends AbstractBiditComponent {

  selectedCrews: Crew[] = [];

  editData: WorkOrderEditModel = {
    workOrder: {
      workOrder_IncludeWeekends: false,
      useSameTimesMultiDay: false,
      workOrderAreas: [],
      workOrderCrews: []
    } as WorkOrderEdit, startTime: this.data.defaultWorkOrderStart, stopTime: this.data.defaultWorkOrderStop
  };

  job: Job = {} as any;
  quoteAreas: WorkOrderQuoteArea[];
  jobCustomItems: WorkOrderCustom[] = [];

  areaAlert: string;
  timeAlert: string;

  constructor(
    deviceDetectorService: DeviceDetectorService,
    private jobService: JobService,
    public dialogRef: MatDialogRef<WorkOrderDialog>,
    private datepipe: DatePipe, private dateService: DateService,
    @Inject(MAT_DIALOG_DATA) public data: WorkOrderDialogData) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    this.jobService.getJob(this.data.quoteId)
      .subscribe({
        next: (data) => {
          this.isRequesting = false;

          this.job = data.job;
          this.quoteAreas = [];
          data.jobAreaSummaries.map(jas => this.quoteAreas = this.quoteAreas.concat(jas.quoteAreas));

          let workOrder = data.job.workOrders.find(wo => wo.workOrder_ID == this.data.workOrderId);
          if (workOrder != null) this.editData.workOrder = workOrder as WorkOrderEdit;

          if (this.editData.workOrder.workOrder_Start)
            this.editData.startTime = this.datepipe.transform(this.editData.workOrder.workOrder_Start, 'hh:mm a');
          if (this.editData.workOrder.workOrder_Stop)
            this.editData.stopTime = this.datepipe.transform(this.editData.workOrder.workOrder_Stop, 'hh:mm a');

          this.selectedCrews = this.data.crews.filter(c => this.editData.workOrder.workOrderCrews.find(woc => c.crew_ID == woc.crew_ID) != null);
          

          this.editData.workOrder.areas = [];
          for (let area of data.jobAreaSummaries) {
            let jobArea = {
              area_Name: area.area_Name,
              quoteAreas: new Array()
            } as JobAreaSummary;

            for (let quoteArea of area.quoteAreas) {
              let existingArea = this.editData.workOrder.workOrderAreas.find(woa => woa.quoteArea_ID == quoteArea.quoteArea_ID);
              let currentArea = this.job.workOrders.find(wo =>
                wo.workOrderAreas.find(woa => woa.quoteArea_ID == quoteArea.quoteArea_ID));
              quoteArea.addWorkOrder = (existingArea != null);
              quoteArea.currentlyAssigned = (currentArea != null);

              jobArea.quoteAreas.push(quoteArea);
            }

            this.editData.workOrder.areas.push(jobArea);
          }

          this.editData.workOrder.jobCustomItems = [];
          const workOrderCustoms = data.jobCustomItems.map((item) => {
            let workOrderCustom = {
              jobCustomItem_ID: item.jobCustomItem_ID,
              quote_ID: item.quote_ID,
              customItemDescription: item.customItemDescription,
              customItemProduct: item.customItemProduct,
              customItem_ItemCost: null,
              customItem_ActualUsage: null,
              customItem_ActualSqrFtg: null,
              workOrders: item.workOrders,
              currentlyAssigned: false,
              addWorkOrder: false
            };
             return workOrderCustom;
          });

          for (let ci of workOrderCustoms) {
            
            let existingArea = this.editData.workOrder.workOrderCustomItems?.find(woci => woci.jobCustomItem_ID == ci.jobCustomItem_ID);
            let currentArea = this.job.workOrders.find(wo =>
              wo.workOrderCustomItems.find(woci => woci.jobCustomItem_ID == ci.jobCustomItem_ID));
            ci.addWorkOrder = (existingArea != null);
            ci.currentlyAssigned = (currentArea != null);

            this.editData.workOrder.jobCustomItems.push(ci);
          }
        }
      });

   
  }

  checkStartValid(): void {
    let startDate = new Date(this.editData.workOrder.workOrder_Start);
    let stopDate = new Date(this.editData.workOrder.workOrder_Stop);
    let minDate = new Date('1/1/2000');

    if (startDate < minDate) {
      this.editData.workOrder.workOrder_Start = '';
      return;
    }

    this.timeAlert = this.dateService.validateDates(startDate, this.editData.startTime, stopDate, this.editData.stopTime);
  }

  checkStopValid(): void {
    let startDate = new Date(this.editData.workOrder.workOrder_Start);
    let stopDate = new Date(this.editData.workOrder.workOrder_Stop);
    let minDate = new Date('1/1/2000');

    if (stopDate < minDate) {
      this.editData.workOrder.workOrder_Stop = '';
      return;
    }

    this.timeAlert = this.dateService.validateDates(startDate, this.editData.startTime, stopDate, this.editData.stopTime);
  }

  saveWorkOrder(form: NgForm): void {
    this.timeAlert = null;
    this.editData.workOrder.quoteArea_IDs = new Array();
    this.editData.workOrder.customItem_IDs = new Array();

    this.checkStartValid();
    this.checkStopValid();

    this.editData.workOrder.workOrder_Start = this.dateService.combineDateString(this.editData.workOrder.workOrder_Start, this.editData.startTime);
    this.editData.workOrder.workOrder_Stop = this.dateService.combineDateString(this.editData.workOrder.workOrder_Stop, this.editData.stopTime);

    for (let area of this.editData.workOrder.areas) {
      for (let quoteArea of area.quoteAreas) {
        if (quoteArea.addWorkOrder) {
          this.editData.workOrder.quoteArea_IDs.push(quoteArea.quoteArea_ID);
        }
      }
    }

    for (let customItem of this.editData.workOrder.jobCustomItems) {
      if (customItem.addWorkOrder) {
        this.editData.workOrder.customItem_IDs.push(customItem.jobCustomItem_ID);
      }
    }

    this.areaAlert = null;
    if (this.editData.workOrder.quoteArea_IDs.length == 0 && this.editData.workOrder.customItem_IDs.length == 0) {
      this.areaAlert = 'No area selected';
      return;
    }

    if (this.timeAlert == null && form.valid) {
      this.editData.workOrder.crew_IDs = this.selectedCrews.map<number>(c => c.crew_ID);
      this.isRequesting = true;

      this.jobService.addWorkOrder(this.data.quoteId, this.editData.workOrder)
        .subscribe(
          {
            next: (data) => this.dialogRef.close(data),
            error: (error: string) => this.onError(error)
          });
    }
  }

  deleteWorkOrder(): void {
    var proceed = confirm($localize`Delete this work order?`);
    if (!proceed) return;

    this.jobService.deleteWorkOrder(this.data.workOrderId)
      .subscribe(
        {
          next: (data) => this.dialogRef.close(data),
          error: (error: string) => this.onError(error)
        });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
